import React, { forwardRef } from 'react'
import { TextInput } from '@olxbr/ds-web'
import styled from 'styled-components'
import { getMaskedValue as getMaskedPhone } from '../../../util/PhonePattern'
import BrazilFlag from '../BrazilFlag'
import PropTypes from 'prop-types'

const PhoneLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 48px;
  border-radius: var(--border-radius-1);
  background-color: var(--color-neutral-80);
`

const FlexWrapper = styled.div`
  display: flex;
  gap: var(--spacing-1);
  ${({ fullwidth }) => fullwidth && 'width: 100%; padding: 0 2px;'};
`

const PhoneInputWrapper = styled(TextInput)`
  flex: 1;
`

export const PhoneInput = forwardRef(
  (
    {
      noPhoneLabel = false,
      onChange,
      stateMessage = 'Digite um telefone válido com DDD.',
      isDirty,
      isTouched,
      error,
      clearErrors,
      fullwidth = false,
      ...rest
    },
    ref
  ) => {
    return (
      <FlexWrapper fullwidth={fullwidth}>
        {!noPhoneLabel && (
          <PhoneLabel>
            <BrazilFlag />
            <div className="flex ml-0-5">+55</div>
          </PhoneLabel>
        )}
        <PhoneInputWrapper
          ref={ref}
          placeholder="(99) 99999-9999"
          aria-label="telefone"
          onChange={e => onChange(getMaskedPhone(e.target.value).pretty)}
          state={isDirty && !!error && 'error'}
          stateMessage={stateMessage}
          onFocus={clearErrors}
          maxLength={15}
          {...rest}
        />
      </FlexWrapper>
    )
  }
)

PhoneInput.propTypes = {
  onChange: PropTypes.func,
  isDirty: PropTypes.bool,
  isTouched: PropTypes.bool,
  error: PropTypes.any,
  stateMessage: PropTypes.string,
  fullwidth: PropTypes.bool,
}
